import React from 'react';

const Avatar = ({ 
  src, 
  alt = 'Avatar', 
  size = 10, 
  className = '' 
}) => {
  const sizeClasses = {
    8: 'size-8',
    10: 'size-10',
    12: 'size-12',
    16: 'size-16',
    32: 'size-32',
  };
  
  return (
    <div 
      className={`bg-center bg-no-repeat aspect-square bg-cover rounded-full ${sizeClasses[size]} ${className}`}
      style={{ backgroundImage: `url(${src})` }}
      data-alt={alt}
      role="img"
      aria-label={alt}
    />
  );
};

export default Avatar;

